import ToggleButton from './ToggleButton';
import ControlsChevronDown from '@/external/icons/ControlsChevronDown';
import ControlsChevronUp from '@/external/icons/ControlsChevronUp';
import { CasinoGameConnectionSorter } from '@/graphql/schema';

type Props = {
  item: {
    value: keyof CasinoGameConnectionSorter;
    label: string;
  };
  current: SelectedSort;
  onSortSelect: (value: keyof CasinoGameConnectionSorter) => void;
  isBitcasino: boolean;
};

const SortItem: FC<Props> = ({ item, current, onSortSelect, isBitcasino }) => {
  const selected = item.value === current.name;
  const desc = current.value === -1;
  return (
    <ToggleButton
      selected={selected}
      onClick={() => onSortSelect(item.value)}
      isBitcasino={isBitcasino}
    >
      {selected &&
        (desc ? (
          <div className="m-2 stroke-[4px] w-4 h-4">
            <ControlsChevronDown />
          </div>
        ) : (
          <div className="m-2 stroke-[4px] w-4 h-4">
            <ControlsChevronUp />
          </div>
        ))}
      <span className="m-2 text-moon-14">{item.label}</span>
    </ToggleButton>
  );
};

export default SortItem;
